import React, { useState, useCallback, useMemo } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { CatalogForm } from '../../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../../components/CatalogForm/validators';
import Http from '../../../../Http';

export const AddClienteGrupo = ({ match, cliente: propCliente, onSave }) => {
  const routeParams = useParams() || {};
  const clientId = propCliente || match?.params?.id || routeParams?.id;

  const [clienteOptions, setClienteOptions] = useState([]);

  const handleSearchCliente = useCallback(async (query) => {
    try {
      const res = await Http.get(`cliente/form/grupos?cliente=${encodeURIComponent(query)}`);
      if (res && !res.error && res.data?.clientes) {
        const options = res.data.clientes.map((c) => ({
          value: String(c.id),
          label: `${c.cliente || c.id} - ${c.cliente_rsocial || c.cliente_nombre || ''}`,
        }));
        setClienteOptions(options);
        return options;
      }
      return [];
    } catch (err) {
      console.error('Error al buscar clientes para grupo', err);
      return [];
    }
  }, []);

  const fields = useMemo(
    () => [
      {
        name: 'cliente',
        label: 'Seleccionar Cliente',
        type: 'autocomplete',
        col: 12,
        required: true,
        validators: [Validators.required('Debe seleccionar un cliente')],
        options: clienteOptions,
        onSearch: handleSearchCliente,
        placeholder: 'Escriba clave o razón social del cliente a agregar...',
        helperText: 'Busque el cliente que desea vincular como miembro de este grupo comercial',
      },
    ],
    [clienteOptions, handleSearchCliente]
  );

  const handleSubmit = useCallback(
    async (values) => {
      try {
        const payload = {
          id_cliente_main: clientId,
          id_cliente: values.cliente,
        };
        const res = await Http.post('cliente-grupo/save', payload);
        return res;
      } catch (err) {
        return { error: true, errMsg: 'Error al agregar cliente al grupo' };
      }
    },
    [clientId]
  );

  const handleSuccess = useCallback(
    (response) => {
      if (onSave) {
        onSave(response);
      }
    },
    [onSave]
  );

  return (
    <div className="mb-4">
      <CatalogForm
        title="Agregar Cliente al Grupo"
        subtitle="Vincule otro cliente a este grupo comercial para consolidar tarifas o convenios"
        fields={fields}
        onSubmit={handleSubmit}
        onSuccess={handleSuccess}
        submitButtonText="Agregar al Grupo"
      />
    </div>
  );
};

export default withRouter(AddClienteGrupo);
